import {
  ADD_PARTICIPANTS_REMINDERS,
  EDIT_PARTICIPANTS_REMINDERS,
  LIST_PARTICIPANTS_REMINDERS,
  VIEW_PARTICIPANTS_REMINDERS,
  DELETE_PARTICIPANTS_REMINDERS,
  // text
  ADD_PARTICIPANTS_REMINDERS_TEXT,
  EDIT_PARTICIPANTS_REMINDERS_TEXT,
  LIST_PARTICIPANTS_REMINDERS_TEXT,
  VIEW_PARTICIPANTS_REMINDERS_TEXT,
  DELETE_PARTICIPANTS_REMINDERS_TEXT,
  PARTICIPANTS_REMINDERS_SUCCESS,
  PARTICIPANTS_REMINDERS_ERROR,
} from "./actionTypes"

// add partcipants invites
export const addParticipantsReminders = (data, history, callback) => {
  return {
    type: ADD_PARTICIPANTS_REMINDERS,
    payload: { data, history, callback }
  }
}

// edit partcipants invites
export const editParticipantsReminders = (data, id, callback) => {
  return {
    type: EDIT_PARTICIPANTS_REMINDERS,
    payload: { data, id, callback },
  }
}

// list partcipants invites
export const listParticipantsReminders = (data, callback) => {
  return {
    type: LIST_PARTICIPANTS_REMINDERS,
    payload: { data, callback },
  }
}

// view partcipants invites
export const viewParticipantsReminders = (data, history) => {
  return {
    type: VIEW_PARTICIPANTS_REMINDERS,
    payload: { data, history },
  }
}

// delete partcipants invites
export const deleteParticipantsReminders = (data, callback) => {
  return {
    type: DELETE_PARTICIPANTS_REMINDERS,
    payload: { data, callback },
  }
}

// text
// add Invites
export const addParticipantsRemindersText = (data, callback) => {
  return {
    type: ADD_PARTICIPANTS_REMINDERS_TEXT,
    payload: { data, callback }
  }
}

// edit Invites
export const editParticipantsRemindersText = (data, id, callback) => {
  return {
    type: EDIT_PARTICIPANTS_REMINDERS_TEXT,
    payload: { data, id, callback },
  }
}

// list Invites
export const listParticipantsRemindersText = (data, id, callback) => {
  return {
    type: LIST_PARTICIPANTS_REMINDERS_TEXT,
    payload: { data, id, callback },
  }
}

// view Invites
export const viewParticipantsRemindersText = (data, history) => {
  return {
    type: VIEW_PARTICIPANTS_REMINDERS_TEXT,
    payload: { data, history },
  }
}

// delete Invites
export const deleteParticipantsRemindersText = (data, callback) => {
  return {
    type: DELETE_PARTICIPANTS_REMINDERS_TEXT,
    payload: { data, callback },
  }
}

export const participantsRemindersSuccess = message => {
  return {
    type: PARTICIPANTS_REMINDERS_SUCCESS,
    payload: message,
  }
}

export const participantsRemindersError = message => {
  return {
    type: PARTICIPANTS_REMINDERS_ERROR,
    payload: message,
  }
}
